import { useMemo } from 'react';

import {
  getSteps,
  selectDisclaimerDesignationOptions,
  selectIsB2CUser,
  selectOnboardingActiveStep,
  selectOnboardingForm,
  useAppSelector,
} from '@/store';

export const useOnboardingSteps = () => {
  const isB2CUser = useAppSelector(selectIsB2CUser);
  const disclaimerDesignationOptions = useAppSelector(
    selectDisclaimerDesignationOptions,
  );
  const onboardingForm = useAppSelector(selectOnboardingForm);
  const activeStep = useAppSelector(selectOnboardingActiveStep);

  const steps = useMemo(
    () =>
      getSteps(onboardingForm, {
        isB2CUser,
        disclaimerDesignationOptions,
      }),
    [onboardingForm, isB2CUser, disclaimerDesignationOptions],
  );

  const activeStepIndex = useMemo(
    () => steps.findIndex(step => step === activeStep),
    [steps, activeStep],
  );

  return {
    steps,
    activeStep,
    activeStepIndex,
  };
};
